import { Link } from 'react-router-dom';
import { ui, cn } from '../lib/ui';

export default function NotFound() {
  return (
    <div className={cn(ui.card, 'text-center')}>
      <h1 className={ui.h1}>Page not found</h1>
      <p className={ui.muted}>The page you&rsquo;re looking for doesn&rsquo;t exist.</p>
      <Link className={ui.btnPrimary} to="/">
        Back to dashboard
      </Link>
    </div>
  );
}
